import { render, staticRenderFns } from "./SteffiProfileTab.vue?vue&type=template&id=8c8a9216&scoped=true&"
import script from "./SteffiProfileTab.vue?vue&type=script&lang=js&"
export * from "./SteffiProfileTab.vue?vue&type=script&lang=js&"
import style0 from "./SteffiProfileTab.vue?vue&type=style&index=0&id=8c8a9216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8a9216",
  null
  
)

export default component.exports